import Dialog from '@/global/guides/Dialog'
import { hasPermission } from '@/hooks/useBackendMenu'
import { useCompensacaoManual } from '@/pages/CompensacaoManual'
import {
    compensacaoManual,
    CreateCompensacaoManual,
    createCompensacaoManualSchema,
} from '@/service/api'
import { useStore } from '@/store'
import { useNavigate } from 'react-router-dom'
import { toast } from 'sonner'
import FormCompensacaoManual from '../forms/FormCompensacaoManual'

export default function AdicionarCompensacaoManualModal() {
    const navigate = useNavigate()
    const { refetch } = useCompensacaoManual()
    const { mutateAsync, isLoading } = compensacaoManual.mutations.useCreate()
    const funcionarioId = useStore(state => state.employeeId)
    const empresaId = useStore(state => state.companyId)
    const competencia = useStore(state => state.selectedCompetence)

    function handleSubmit(data: CreateCompensacaoManual) {
        if (!funcionarioId) {
            toast.error('Selecione um funcionário')
            return
        }

        if (!empresaId) {
            toast.error('Selecione uma empresa')
            return
        }

        mutateAsync(
            {
                ...data,
                empresaId,
                funcionarioId,
                competencia,
            },
            {
                onSuccess: () => {
                    toast.success('Compensação manual criada com sucesso!')
                    navigate(-1)
                    refetch()
                },
                onError: err => {
                    toast.error(
                        err.message || 'Erro ao criar compensação manual',
                    )
                },
            },
        )
    }

    return (
        <Dialog.Root
            height="auto"
            width="45rem"
            onSubmit={handleSubmit}
            loading={isLoading}
            schema={createCompensacaoManualSchema}
            defaultValues={{
                tipo: 'COMPENSAR',
                destinos: [],
            }}
            open={hasPermission(['create', 'CompensaçãoManual'])}
        >
            <Dialog.Title>Nova Compensação Manual</Dialog.Title>
            <Dialog.Content dividers>
                <FormCompensacaoManual />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
